<template>
  <div class="category-container">
    <div class="category-cont">
      <div
        v-for="category in categories"
        ref="linksRef"
        class="category-item"
        :key="category.id"
        :class="{ active: category === value }"
      >
        <div
          @click="onClickCategory(category)"
          :style="{
            backgroundImage: `${
              !category.thumbnail
                ? 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),'
                : 'var(--gradient),'
            } url(${category.thumbnail && category.thumbnail.url})`,
          }"
          class="category"
        >
          <p class="title">
            {{ category.title }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Category",
    data() {
      return {};
    },
    mounted() {
      this.scrollIntoActiveCategory();
    },
    watch: {
      value(activeCategory) {
        const activeIndex = this.categories.findIndex(
          (element) => element.id === activeCategory.id
        );
        this.scrollIntoActiveCategory(activeIndex);
      },
    },
    methods: {
      onClickCategory(item) {
        window.scrollTo({ top: 0, behavior: "auto" });
        this.$emit("input", item);
      },
      scrollIntoActiveCategory(index = 0) {
        if (this.$refs && this.$refs.linksRef && this.$refs.linksRef[index]) {
          try {
            this.$refs.linksRef[index].scrollIntoView({
              behavior: "auto",
              block: "center",
              inline: "center",
            });
          } catch (e) {
            console.log(e);
          }
        }
      },
    },
    props: {
      categories: {
        type: Array,
        required: true,
      },
      value: {
        type: Object,
      },
    },
  };
</script>

<style scoped lang="scss">
  .category-container {
    border-radius: 10px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: 750px;
    border: 1px solid gray;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 25px;
    margin-right: 15px;
    background-color: white;
    padding: 12px;
    padding-bottom: 8px;
    top: 96px;
    bottom: 30px;
    z-index: 10;
    gap: 12px;
    width: 240px;

    @media (max-width: 700px) {
      flex-direction: row;
      margin-right: 0;
      gap: 8px;
      margin-bottom: 20px;
      border-right: 0;
      position: relative;
      top: auto;
      bottom: auto;
      z-index: 0;
      height: 125px;
      width: 100%;
    }

    .category-cont {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 12px;
      overflow: hidden auto;
      height: 100%;
      padding-right: 8px;
      align-items: center;
      width: 100%;

      @media (max-width: 700px) {
        flex-direction: row;
        overflow: auto hidden;
        padding-bottom: 6px;
        gap: 8px;
        border-right: 0;
        position: relative;
        top: auto;
        bottom: auto;
        z-index: 0;
      }
    }

    ul {
      list-style-type: none;
    }
  }

  .category-item {
    display: flex;
    flex-direction: column;

    .category {
      width: 180px;
      height: 80px;
      white-space: nowrap;
      cursor: pointer;
      border-radius: 8px;
      background-color: #1a191983;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 16px;
      position: relative;
      margin: 0 1px;
      transition: 0.3s all;
      background-size: cover;
      background-position: center;
      --gradient: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7));
      overflow: hidden;
      position: relative;

      .title {
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #fff;
        text-align: center;
        font-size: 12px;
        max-width: 180px;
        transition: all 300ms ease-in-out;
      }
    }

    &.active .category {
      background-color: #1a1919e8;
      font-weight: 500;
      --gradient: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
      border: 1px solid rgba(var(--vs-primary), 1);
      height: 90px;
      width: 190px;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 10px;
    }
  }
</style>
